module.exports = __webpack_public_path__ + "img/logoComplement.40d22512.jpg";